const initialState = {
  data: null,
};

const routeCurrentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_ROUTE_CURRENT": {
      return {
        data: action.payload,
      };
    }

    default:
      return state;
  }
};

export default routeCurrentReducer;
